export const PATHS = {
  ID: 'identification',
  PROOF_OF_ADDRESS: 'proof-of-address',
  PROOF_OF_INCOME: 'proof-of-income',
  PROOF_OF_ACTIVITY: 'proof-of-activity',
  ID_OFICIAL: 'official-id',
  ID_PASSPORT: 'passport',
  PROOF_OF_INCOME_BANK_STATEMENT: 'bank-statement',
  PROOF_OF_INCOME_PAYSLIP: 'payslip',
  PROOF_OF_ACTIVITY_TAX_SITUATION: 'proof-of-business',
  PROOF_OF_ACTIVITY_OPERATING_LICENSE: 'operating-license',
};
